'use es6';

var AllowedUtms = {
  UTM_SOURCE: 'UTM_SOURCE',
  UTM_MEDIUM: 'UTM_MEDIUM',
  UTM_ID: 'UTM_ID'
};
export default AllowedUtms;